import voipApi from '~/api/voip'

const fetchStatus = ({ commit, state }) => {
  if (state.fetchingStatus === false && state.status === null) {
    commit('SET_FETCHING_STATUS', true)

    voipApi
      .getStatus()
      .then(response => {
        commit('SET_STATUS', response.status)
      })
      .finally(() => {
        commit('SET_FETCHING_STATUS', false)
      })
  }
}

const setStatus = ({ commit }, status) => {
  voipApi
    .setStatus(status)
    .then(response => {
      commit('SET_STATUS', status)
    })
    .finally(() => {
      commit('SET_FETCHING_STATUS', false)
    })
}

export default {
  fetchStatus,
  setStatus,
}
